module.exports = __webpack_public_path__ + "img/KTW.c55ee6e0.svg";